/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesGetAgentSchedule } from "../../funcs/agentSchedulesGetAgentSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAgentScheduleRequest$inboundSchema,
};

export const tool$agentSchedulesGetAgentSchedule: ToolDefinition<typeof args> =
  {
    name: "agent-schedules-get-agent-schedule",
    description: `Retrieve an agent schedule`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await agentSchedulesGetAgentSchedule(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
